import { IntegrationStates } from 'models/integrations/integration';
import { IntegrationTypes } from 'models/integrations/integrationTypeHandler';
import KPIDTO from '../kpi/kpiDTO';
import TaskDTO from '../tasks/taskDTO';
import { ExternalCheckScheduleDTO } from './externalCheckScheduleDTO';
import { IntegrationConnectionDTO } from './integrationConnectionDTO';
import { IntegrationGroupDTO } from './integrationGroupDTO';
import { IntegrationRunDTO } from './integrationRunDTO';
import { IntegrationTypeDTO } from './integrationTypeDTO';

export class IntegrationDTO {
  integrationId: number;

  integrationTypeId: IntegrationTypes;

  state: IntegrationStates;

  config: string;

  integrationConnectionId?: number;

  connection?: IntegrationConnectionDTO;

  kpiId: number;

  templateId?: number;

  template?: TaskDTO;

  recurrencePattern: string | undefined;

  ownerId?: string;

  ownerRoleId?: string;

  kpi: KPIDTO;

  integrationType?: IntegrationTypeDTO;

  runs?: IntegrationRunDTO[];

  integrationGroupId: number;

  integrationGroup?: IntegrationGroupDTO;

  //set only on an entry synthesized for a SkillControl check (integrationTypeId ExternalCheck)
  externalCheck?: ExternalCheckScheduleDTO;

  constructor() {
    this.integrationId = 0;
    this.kpiId = 0;
    this.kpi = new KPIDTO();
    this.integrationGroupId = 0;
    this.integrationTypeId = IntegrationTypes.MS_MFA;
    this.state = IntegrationStates.Disabled;
    this.config = '';
  }
}
